
<component
  :is="mobile ? simpleWrapperCmp : QTd"
  key="domain"
  v-bind="$attrs"
  :props="props"
  class="cmp-bundle-title"
  :class="{
    'td-domain mobile': mobile,
    'item-domain q-mb-lg': !mobile,
  }"
>
  <small
    v-if="percentageDiscount"
    class="bundle-title text-bold q-mb-sm ws-text-primary"
  >
    <ws-icon name="rocket" class="q-mr-sm ws-text-highlighted" />
    <span class="bundle-text">
      {{ $t('domain_checker.bundle.title.text') }}
      <span class="ws-text-highlighted">{{
        $t('domain_checker.bundle.title.emphasized', {
          savings: percentageDiscount,
          tld: bundle.discountedDomain.tld,
          price: $n(
            bundle.discountedDomain.price.actualPrice || 0,
            'currency'
          ),
        })
      }}</span>
    </span>
  </small>
  <div class="domain-names ws-text-primary">
    <span class="domain-name q-mr-sm">{{ bundle.mainDomain.name | rmTld(bundle.mainDomain.tld)
    }}<span class="tld text-bold">.{{ bundle.mainDomain.tld }}</span></span>
    <br />
    <span class="domain-name plus-sign ws-pseudo-text-highlighted">{{
      bundle.discountedDomain.name | rmTld(bundle.discountedDomain.tld)
    }}<span class="tld text-bold">.{{ bundle.discountedDomain.tld }}</span>
    </span>
  </div>
</component>
